<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11o7AUH/tc-custom/9781250061157.jpg?1718183632803" alt="This image is the cover for the book Unforgettable"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Unforgettable
      </h1>
      <p class="bookDescription body article font2">
        <p>"I'm getting a life's lesson about grace from my mother in the ICU. <br/>We never stop learning from our mothers, do we?" <br/>UNFORGETTABLE is a son's spirited, affecting, and inspiring tribute to his remarkable mother and the love between parent and child. <br/><br/>When NPR's Scott Simon began tweeting from his mother's hospital room in July 2013, he didn't know that his missives would soon spread well beyond his 1.2 million Twitter followers. Squeezing the magnitude of his final days with her into 140-character updates, Simon's evocative and moving meditations spread virally. Over the course of a few days, Simon chronicled his mother's death and reminisced about her life, revealing her humor and strength, and celebrating familial love. <br/><br/>UNFORGETTABLE, expands on those famous tweets to create a memoir that is rich, deeply affecting, heart-wrenching, and exhilarating. His mother was a glamorous woman of the Mad Men–era; she worked in nightclubs, modeled, dated mobsters and movie stars, and was a brave single parent to young Scott Simon. Spending their last days together in a hospital ICU, mother and son reflect on their lifetime's worth of memories, recounting stories laced with humor and exemplifying resilience. <br/><br/>UNFORGETTABLE is not only one man's rich and moving tribute to his mother's colorful life and graceful death, it is also a powerful portrayal of the universal bond between mother and child.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Scott Simon
      </h2>
      
      <p class="authorDescription body article"><P>SCOTT SIMON is one of America's most admired writers and broadcasters, having reported from all over the world and from many wars. He is now the award-winning host of <I>Weekend Edition Saturday</I>. With over 4 million listeners it is the most-listened to news program on NPR. Simon has won a Peabody and an Emmy for his reporting and also has over 1.2 million followers on Twitter.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Flatiron Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4359dccd